/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { setExperimentCookie } from 'helpers/experiments';
import getConfig from 'next/config';

import ModalProvider from 'context/modal';
import CustomerProvider from 'context/customer';
import ToastProvider from 'context/toast';
import ModalWrapper from 'components/shared/Modals/ModalWrapper/ModalWrapper';
import packageJSON from '../package.json';
import 'styles/app.scss';

const { publicRuntimeConfig } = getConfig();

datadogRum.init({
  applicationId: publicRuntimeConfig.dataDogApplicationID,
  clientToken: publicRuntimeConfig.dataDogClientToken,
  version: packageJSON.version,
  env: publicRuntimeConfig.deployEnvironment,
  sampleRate: 100,
  trackInteractions: true,
  trackLongTasks: false,
  trackResources: false,
  sessionReplaySampleRate: 0,
});

setExperimentCookie();

function Marketplace({ Component, pageProps }) {
  return (
    <CustomerProvider>
      <ToastProvider>
        <ModalProvider>
          <ModalWrapper />
          <Component {...pageProps} />
        </ModalProvider>
      </ToastProvider>
    </CustomerProvider>
  );
}

export default Marketplace;
